import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { ApiError, AuthService, ConfigService, DataTablesService, GuidService, MessageService } from '../../../../../core';
import { ConfigEmpresa, createNomeRepresentante } from '../../../../configuracoes/app/empresa';
import { Representante } from '../../../representante';
import { clienteCadastroBaixado, clienteCadastroCliente, clienteCadastroOutros, clienteCadastroProspect } from '../../cadastro/cliente-cadastro';
import { ClienteCadastroBadgePipe, ClienteCadastroPipe } from '../../cadastro/pipes';
import { Cliente } from '../../cliente';
import { ClienteCrudHttpService } from '../../services';
import { clienteSituacaoAtivo, clienteSituacaoBaixado, clienteSituacaoBloqueado, clienteSituacaoCongelado, clienteSituacaoInativo, clienteSituacaoNovo, clienteSituacaoOutros, clienteSituacaoPositivo, clienteSituacaoPreBaixado, clienteSituacaoPreInativo } from '../../situacao/cliente-situacao';
import { ClienteSituacaoBadgePipe, ClienteSituacaoPipe } from '../../situacao/pipes';
import { ClienteFilter } from '../cliente-filter';
import { ClienteFilterComponent } from '../cliente-filter.component';

@Component({
    selector: 'sgt-cliente-filter-modal',
    templateUrl: './cliente-filter-modal.component.html',
})
export class ClienteFilterModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;
    isRepresentante: boolean;

    @Input() idModal: string;

    /** Cadastro */
    @Input() somenteClientesEmCarteira: boolean = null; // Somente os clientes em carteira (clientes com cadastro igual a cliente)
    @Input() somenteClientesEmCarteiraAtiva: boolean = null; // Somente os clientes em carteira (clientes com cadastro igual a cliente) que estão com situação igual a Ativo
    @Input() somenteClientesEmCarteiraInativa: boolean = null; // Somente os clientes em carteira (clientes com cadastro igual a cliente) que estão com situação igual a Inativo
    @Input() somenteClientes: boolean = null; // Somente os clientes com cadastro igual a cliente
    @Input() somenteClientesProspects: boolean = null; // Somente os clientes com cadastro prospect
    @Input() somenteClientesCongelados: boolean = null; // Somente os clientes com cadastro congelado
    @Input() somenteClientesBloqueados: boolean = null; // Somente os clientes com cadastro bloqueado
    @Input() somenteClientesBaixados: boolean = null; // Somente os clientes com cadastro baixado
    @Input() somenteClientesOutros: boolean = null; // Somente os clientes com cadastro outros
    @Input() cadastroProspect = false;
    @Input() cadastroCliente = false;
    @Input() cadastroBaixado = false;
    @Input() cadastroOutros = false;

    /** Situação */
    @Input() somenteClientesAtivos: boolean = null; // Somente os clientes com a situação ativo
    @Input() somenteClientesInativos: boolean = null; // Somente os clientes com a situação inativo
    @Input() situacaoNovo = false;
    @Input() situacaoPositivo = false;
    @Input() situacaoAtivo = false;
    @Input() situacaoPreInativo = false;
    @Input() situacaoInativo = false;
    @Input() situacaoCongelado = false;
    @Input() situacaoBloqueado = false;
    @Input() situacaoPreBaixado = false;
    @Input() situacaoBaixado = false;
    @Input() situacaoOutros = false;

    /** Se é para considerar somente os clientes que são Centrais de Compras V1 */
    @Input() somenteCentralDeCompraV1 = false;
    /** Se é para considerar somente os clientes que são Centrais de Compras */
    @Input() somenteCentralDeCompra = false;
    /** Se é para considerar somente os clientes que estão disponíveis para serem participantes de uma central de compras */
    @Input() somenteParticipaveisCentalDeCompra = false;
    /** Serve para informar qual é o cliente atual em que o Typeahead está sendo utilizado para pesquisa */
    @Input() idClienteAtual: number = null;
    /** ID's dos clientes que devem ser ignorados e não devem retornar nos resultados do typeahead */
    @Input() idsIgnore: number[] = [];

    @Output() selectEntity = new EventEmitter<Cliente>();
    elModal: any;
    isSelectRegistered = false;

    entities: Cliente[];
    idDataTable: string;
    dataTable: any;
    filter: ClienteFilter;
    @ViewChild('clienteFilter') clienteFilter: ClienteFilterComponent;
    @ViewChild('modalBody') modalBody: ElementRef;


    constructor(private el: ElementRef,
                private authService: AuthService,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private clienteCadastroPipe: ClienteCadastroPipe,
                private clienteCadastroBadgePipe: ClienteCadastroBadgePipe,
                private clienteSituacaoPipe: ClienteSituacaoPipe,
                private clienteSituacaoBadgePipe: ClienteSituacaoBadgePipe,
                private guidService: GuidService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isRepresentante = this.authService.isRepresentante();

        this.create();
        this.idDataTable = this.guidService.generate();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.filter = new ClienteFilter();
                this.setDefaultFilters();
                this.createTable();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Ao iniciar o filtro */
    onFilterInitialized() {
        // this.search();
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        this.search();
    }

    /** Ao limpar o filtro */
    onFilterCleaned() {
        this.setDefaultFilters();
        this.search();
    }

    open() {
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    search() {
        this.dataTable?.ajax.reload();
    }

    private closeFilter() {
        this.clienteFilter.close();
        jQuery(this.modalBody.nativeElement).scrollTop(0);
    }

    private hiddenTableColumns() {
        const columns: any[] = [];
        if (this.isRepresentante) { // Se for representante, ocultamos a coluna do representante
            columns.push({visible:  false, targets: 5});
        }

        return columns;
    }

    /** Seta os filtros padrões para realziar a pesquisa dos clientes */
    private setDefaultFilters() {
        if (!this.filter) {
            return;
        }

        /** Cadastro */
        this.filter.somenteClientesEmCarteira = this.somenteClientesEmCarteira;
        this.filter.somenteClientesEmCarteiraAtiva = this.somenteClientesEmCarteiraAtiva;
        this.filter.somenteClientesEmCarteiraInativa = this.somenteClientesEmCarteiraInativa;
        this.filter.somenteClientes = this.somenteClientes;
        this.filter.somenteClientesProspects = this.somenteClientesProspects;
        this.filter.somenteClientesCongelados = this.somenteClientesCongelados;
        this.filter.somenteClientesBloqueados = this.somenteClientesBloqueados;
        this.filter.somenteClientesBaixados = this.somenteClientesBaixados;
        this.filter.somenteClientesOutros = this.somenteClientesOutros;
        // Prospect
        if (this.cadastroProspect) {
            this.filter.cadastros.push(clienteCadastroProspect.id);
        }
        // Cliente
        if (this.cadastroCliente) {
            this.filter.cadastros.push(clienteCadastroCliente.id);
        }
        // Baixado
        if (this.cadastroBaixado) {
            this.filter.cadastros.push(clienteCadastroBaixado.id);
        }
        // Outros
        if (this.cadastroOutros) {
            this.filter.cadastros.push(clienteCadastroOutros.id);
        }

        /** Situação */
        this.filter.somenteClientesAtivos = this.somenteClientesAtivos;
        this.filter.somenteClientesInativos = this.somenteClientesInativos;
        // Novo
        if (this.situacaoNovo) {
            this.filter.situacoes.push(clienteSituacaoNovo.id);
        }
        // Positivo
        if (this.situacaoPositivo) {
            this.filter.situacoes.push(clienteSituacaoPositivo.id);
        }
        // Ativo
        if (this.situacaoAtivo) {
            this.filter.situacoes.push(clienteSituacaoAtivo.id);
        }
        // PreInativo
        if (this.situacaoPreInativo) {
            this.filter.situacoes.push(clienteSituacaoPreInativo.id);
        }
        // Inativo
        if (this.situacaoInativo) {
            this.filter.situacoes.push(clienteSituacaoInativo.id);
        }
        // Congelad
        if (this.situacaoCongelado) {
            this.filter.situacoes.push(clienteSituacaoCongelado.id);
        }
        // Bloqueado
        if (this.situacaoBloqueado) {
            this.filter.situacoes.push(clienteSituacaoBloqueado.id);
        }
        // PreBaixado
        if (this.situacaoPreBaixado) {
            this.filter.situacoes.push(clienteSituacaoPreBaixado.id);
        }
        // Baixado
        if (this.situacaoBaixado) {
            this.filter.situacoes.push(clienteSituacaoBaixado.id);
        }
        // Outros
        if (this.situacaoOutros) {
            this.filter.situacoes.push(clienteSituacaoOutros.id);
        }

        // Somente central de compra V1
        this.filter.somenteCentralDeCompraV1 = this.somenteCentralDeCompraV1;
        // Somente central de compra
        this.filter.somenteCentralDeCompra = this.somenteCentralDeCompra;
        // Somente os clientes que estão disponíveis para serem participantes de uma central de compras
        this.filter.somenteParticipaveisCentalDeCompra = this.somenteParticipaveisCentalDeCompra;
        // Cliente atual
        this.filter.idClienteAtual = this.idClienteAtual;
        // Clientes a serem ignorados
        this.filter.idsIgnore = this.idsIgnore;
    }

    /** Cria a Datatables assíncrona */
    createTable() {
        this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
            serverSide: true,
            processing: true,
            pageLength: 12,
            searching: false,
            columns: [
                {
                    data: null,
                    className: 'col-options',
                    visible: false
                },
                {data: 'pessoa.codigoIntegracaoErp', className: 'col-codigo-integracao-erp'},
                {
                    data: 'pessoa.nome',
                    className: 'col-nome',
                    render: (data: any, _: any, entity: Cliente) => {
                        let nome = data;
                        if (!this.isRepresentante && !entity.clientePrimario) {
                            nome += '<span class="badge badge-primary badge-cliente-secundario" title="Isto significa que este cliente foi cadastrado a partir de um outro cadastro de cliente com o mesmo CNPJ/CPF">Secundário</span>'
                        }
                        return nome;
                    },
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                },
                {
                    data: 'pessoa.nomeFantasia',
                    className: 'col-nome-fantasia',
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                },
                {data: 'pessoa.cnpjCpf', className: 'col-cnpj-cpf'},
                {
                    data: 'representante',
                    className: 'col-nome-representante',
                    render: (data: Representante, _: any, entity: Cliente) => {
                        if (data && data.pessoa) {
                            return ` ${data.pessoa.codigoIntegracaoErp} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, data.pessoa.nome, data.pessoa.nomeFantasia)} `;
                        }
                        return '';
                    },
                    createdCell: (td, cellData: Representante, rowData, row, col) => {
                        if (cellData) {
                            td.title = ` ${cellData.pessoa.codigoIntegracaoErp} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, cellData.pessoa.nome, cellData.pessoa.nomeFantasia)} `;
                        }
                    }
                },
                {
                    data: 'cadastro',
                    className: 'col-cadastro text-center',
                    render: (data: number) => `<span class="${this.clienteCadastroBadgePipe.transform(data)}">${this.clienteCadastroPipe.transform(data)}</span>`
                },
                {
                    data: 'situacao',
                    className: 'col-situacao text-center',
                    render: (data: number) => `<span class="${this.clienteSituacaoBadgePipe.transform(data)}">${this.clienteSituacaoPipe.transform(data)}</span>`
                }
            ],
            columnDefs: this.hiddenTableColumns(),
            ajax: (data, callback, settings) => { // Evento Ajax para pesquisar os clientes
                this.closeFilter();

                const order = data.order[0];
                this.clienteCrudHttpService.searchWithFilter(this.filter, data.draw, data.start, data.length, order.column, order.dir)
                    .subscribe(
                        response => {
                            this.entities = response.data;
                            callback(response);
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, 'Erro ao pesquisar os clientes', error);
                            callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                        }
                    );
            }
        })
        .then(dataTable => {
            this.dataTable = dataTable;

            // Somente vincula o evento de clique para selecionar a entidade uma única vez
            if (!this.isSelectRegistered) {
                this.isSelectRegistered = true;

                const myself = this;
                $(`#${this.idDataTable} tbody`).on( 'click', 'tr', function() {
                    const table = ($(`#${myself.idDataTable}`) as any).DataTable();
                    const data = table.row(this).data();

                    if (data) {
                        myself.onSelectEntity(data);
                    }
                } );
            }
        });
    }

    /** Ao selecionar o cliente emitimos o evento de seleção e fechamos o modal */
    private onSelectEntity(entity: Cliente) {
        this.selectEntity.emit(entity);
        this.close();
    }

}
